import {
  set,
  update,
} from 'lodash/fp';
import {
  RECEIVE_DATA,
  UPDATE_DATA,
} from 'config/types';

export default function indicatorReducer(state = {}, { type, payload = {} }) {
  const { key, data } = payload;
  if (RECEIVE_DATA === type && 'indicator' === key) {
    const { dataView } = data;
    if ('undefined' === typeof state.allIndicators[dataView]) {
      const ret = set(key, { ...data }, state);
      return {
        ...state,
        ...ret,
        isFetching: state.isFetching.filter((x) => x !== key),
      };
    }
    const { updatedFromWP = false } = state.allIndicators[dataView];
    return {
      ...state,
      indicator: updatedFromWP ? {
        ...data,
        ...state.allIndicators[dataView].bySlug[data.slug],
      } : {
        ...data,
      },
      isFetching: state.isFetching.filter((x) => x !== key),
    };
  }
  if (UPDATE_DATA === type && 'indicator' === key) {
    return update(key, { ...data }, state);
  }
  return state;
}



// WEBPACK FOOTER //
// ./app/reducers/indicator.js